<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
// import "./stroe";
import { mapActions,mapGetters ,mapMutations} from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations("topPartner", ["setTopPartner"]),
    ...mapActions("topPartner", ["getTopPartner"]),
   
  },
  computed:{
    ...mapGetters('topPartner',['filterTopPartnerList']),
  },
  mounted() {
   
  }
};
</script>

<style lang="less" scoped></style>
